import { createStore } from 'vuex'

export default createStore({
  state: {
    sendUrl: '', //Урл куда отправлять форму
    sendExtUrl: '', //Урл куда отправлять расширения файлов
    allowedext: ["jpg","jpeg", "png", "pdf", "tif", "tiff"],
    show: true,
    thanksShow: false,
    step: 1,
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    DaDataUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    loads: [],
    codeTimer: null,
    codeSeconds: 0,
    form: {
      contracts: [
        { id: '', date: '' }
      ],
      applicant: {
        name: '',
        birthdate: '',
        doc: {
          type: '',
          series: '',
          number: '',
          code: '',
          releasedate: ''
        },
        address: '',
        tel: '',
        email: '',
        onbehalf: '',
        relationship: ''
      },
      beneficiaries: [],
      insuredperson: {
        name: '',
        birthdate: ''
      },
      event: {
        date: '',
        type: '',
        deathdate: '',
        reason: '',
        description: ''
      },
      files: {
        blank: [],
        passport: [],
        vipiska: [],
        criminalCase: [],
        deathproof: [],
        legacyproof: [],
        bodyresearchproof: [],
        invalidproof: [],
        medprotocol: [],
        additinal: [],
      },
      bankdata: {
        receiver: '',
        BIK: '',
        bankname: '',
        accountNumber: '',
        confirm: false
      }
    }
  },
  mutations: {
    addLoad(state, val){
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val){
      state.loads = state.loads.filter(el=>el!=val)
    },
    setShow(state,val) {
      state.show = val
    },
    setThanksShow(state, val){
      state.thanksShow = val
    },
    nextStep(state){
      state.step ++
    },
    prevStep(state) {
      state.step --
    },
    setStep(state, val) {
      state.step = val
    },
    addContract(state) {
      state.form.contracts.push({ id: '', date: '' })
    },
    setBeneficiaries(state, val) {
      state.form.beneficiaries = val
    },
    setCodeTimer(state, val){
      state.codeTimer = val
    },
    setCodeSeconds(state, val){
      state.codeSeconds = val
    },
  },
  actions: {
    async sendAndFinish({ state, commit }){
      console.log(state.form)
      commit('setShow', false)
      commit('setThanksShow', true)
    },
    async sendCode({ state, dispatch }) {
      if (state.codeTimer) return
      dispatch('launchTimer')
      let tel = state.form.applicant.tel
      tel;
      //TODO
    },
    async checkCode(ctx, code) {
      //TODO
      ctx;
      code;
    },
    launchTimer({state, commit}){
      commit('setCodeSeconds', 60)
      commit('setCodeTimer', setInterval(()=>{
        commit('setCodeSeconds', state.codeSeconds - 1)
        if (state.codeSeconds == 0) {
          clearInterval(state.codeTimer)
          commit('setCodeTimer', null)
        }
      }, 1000))
    }
  },
  getters: {
    loading(state){
      return state.loads.length ? true : false
    },
    contractCount(state) {
      return state.form.contracts.length
    },
    timerstring(state) {
      let min = (Math.floor(state.codeSeconds / 60)+'').padStart(2,'0')
      let sec = ((state.codeSeconds % 60)+'').padStart(2,'0')
      return min + ':' + sec
    }
  }
})
